module.exports = __webpack_public_path__ + "static/media/add_fact_second.f3b45cb0.png";